import IconComponent from "app/shared-components/IconComponent";
import React, { useState, useRef, useEffect, useMemo, useCallback } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  Box,
  Button,
  Checkbox,
  Container,
  Fab,
  FormControlLabel,
  Grid,
  Icon,
  IconButton,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  tableCellClasses,
} from "@mui/material";
import OAuthService from "src/app/auth/services/oAuthService";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import oAuthServiceConfig from "src/app/auth/services/oAuthService/oAuthServiceConfig";
import AgGridTable from "../../utilities/AgGridTable";
import ListPageHeader from "../../utilities/ListPageHeader";
import { makeStyles, styled } from "@mui/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  addButton: {
    position: "absolute",
    left: -55,
    top: 70,
    width: 46,
    height: 46,
  },
}));

const Action = (props) => {
  const { data, btnDelete } = props
  console.log(data)
  return (
    <>
      <Tooltip title={"Delete"}>
        <IconButton>
          <FuseSvgIcon size={16} color="action">
            heroicons-solid:trash
          </FuseSvgIcon>
        </IconButton>
      </Tooltip>
    </>
  );
};

const processData = (trainers) => {
  console.log(trainers)
  const flattenedData = [];
  const flattenRowRecursive = (row, parentPath) => {
    row['trainerId'] = row.id.toLocaleString();
    row['trainerName'] = row.trainerName;
    row['designation'] = row.designation;
    row['selectedCourse'] = row.trainingCourse.map(course => course.name);
    row['selectTopic'] = row.trainerCourse.map(course => {
      course.trainingTopics.map(topic => {
        return topic.topicName
      })
    })
    const dataPath = [...parentPath, row.orderCategory];
    flattenedData.push({ ...row, dataPath });
    if (row.subCategories) {
      row.subCategories.forEach((underling) =>
        flattenRowRecursive(underling, dataPath)
      );
    }
  };
  trainers.forEach((row) => flattenRowRecursive(row, []));
  return flattenedData;
}


const Trainers = (props) => {
  const classes = useStyles(props);

  const url = `http://localhost:9095/${oAuthServiceConfig.trainersList}`;
  const urlEmployee = `${process.env.REACT_APP_HR_API_KEY_URL}${oAuthServiceConfig.employees}`;

  const [selectedRows, setSelectedRows] = useState([]);
  const [rowData, setRowData] = useState();
  const [gridApi, setGridApi] = useState(null);
  const [snackState, setSnackState] = useState(false);
  const [successMsg, setSuccessMsg] = useState();
  const [deleteDisable, setDeleteDisable] = useState(true);
  const [error, setError] = useState("");
  const [employeeData, setEmployeeData] = useState();
  const perPage = 10;
  const gridRef = useRef();
  const navigate = useNavigate();
  const [columnDefs, setColumnDefs] = useState([
    {
      field: 'trainerCode', enableRowGroup: true, cellEditor: "agTextCellEditor",
      cellEditorParams: {
        precision: 0,
      },
    },
    { field: 'trainerName', enableRowGroup: true, headerName: "Trainer Name" },
    { field: 'designation', enableRowGroup: true },
    { field: 'selectCourse', enableRowGroup: true },
    { field: 'selectTopic', enableRowGroup: true },
    { field: 'profileUpload', enableRowGroup: true },
    {
      cellRenderer: (data) => <Action data={data} btnDelete={onBtDeleteRow} />,
      minWidth: 50,
      maxWidth: 50,
      editable: false,
    },
  ]);

  // const loadEmployeeData = async () => {
  //   try {
  //     const list = await OAuthService.getList(url + `?sort=name,asc&size=1000`);
  //     let employees = list.data?._embedded?.employees;
  //     employees = employees.map((employee) => {
  //       const empFullName = `${employee.empFirstName} ${employee.empMiddleName} ${employee.empLastName}`;
  //       employee.employeeName = empFullName;
  //       return employee;
  //     });
  //     setEmployeeData(employees);
  //   } catch (error) {
  //     setError(error.message);
  //   }
  // }

  const loadTrainerData = async () => {
    try {
      const list = await OAuthService.getList(url);
      let trainerList = list.data?._embedded?.trainers;
      // employees = employees.map((employee) => {
      // const empFullName = `${employee.empFirstName} ${employee.empMiddleName} ${employee.empLastName}`;
      // employee.employeeName = empFullName;
      // return employee;
      setRowData(processData(trainerList._embedded.trainers));
    } catch (error) {
      setError(error.message);
    }
  }

  const loadEmployeeData = async () => {
    try {
      const list = await OAuthService.getList(urlEmployee);
      let trainerList = list.data?._embedded?.trainers;
      employees = employees.map((employee) => {
        const empFullName = `${employee.empFirstName} ${employee.empMiddleName} ${employee.empLastName}`;
        employee.employeeName = empFullName;
        return employee;
      }
      )
    } catch (error) {
      setError(error.message);
    }
  }

  const onBtDeleteRow = useCallback(
    (event) => {
      const selectedRow = [event.node.data];
      confirmAlert({
        title: "Confirm to delete",
        message: "Are you sure to delete.",
        buttons: [
          {
            label: "Yes",
            onClick: () => {
              rowData?.splice(event.node.rowIndex, 1);
              gridRef?.current?.api.applyTransaction({ remove: selectedRow });
              // selectedRow.map(async (row) => {
              //   // const id = row?._links?.self?.href.split("/").pop();
              //   // await OAuthService.deleteData(url, id);
              //   setSuccessMsg("Data deleted Successfully");
              //   setSnackState(true);
              // });
            },
          },
          {
            label: "No",
            onClick: () => { },
          },
        ],
      });
    },
    [gridRef, rowData]
  );

  const onBtAdd = useCallback(
    (event) => {
      let newRow = {
        trainerCode: "",
        trainerName: "",
        designation: "",
        selectCourse: "",
        selectTopic: "",
        profileUpload: "",
      };
      const RowIndex = event.node;

      rowData && rowData?.splice(RowIndex, 0, newRow);
      gridRef.current.api.applyTransaction({
        add: [newRow],
        addIndex: RowIndex,
      });
      gridRef.current.api.refreshCells();
      setTimeout(() => {
        gridRef.current.api.setFocusedCell(RowIndex, "trainerName");
        gridRef.current.api.startEditingCell({
          rowIndex: RowIndex,
          colKey: "trainerName",
        });
      }, 800);
    },
    [rowData]
  );

  useEffect(() => {
    if (gridApi) {
      setEmployeeData(loadEmployeeData());
      loadTrainerData();
    }
  }, [gridApi]);

  const handlePurge = (e) => {
    selectedRows.map(async (row) => {
      try {
        await OAuthService.deleteData(url, row.employeeId);
        setSuccessMsg("Data deleted Successfully")
        setSnackState(true);
        loadData();
      } catch (error) {
        console.log("eror", error);
        setError(error.message);
      }
    })
  };

  const onGridReady = (params) => {
    loadTrainerData();
    setGridApi(params.api);
  };

  const onSelectionChanged = (params) => {
    setSelectedRows(params.api.getSelectedRows());
  }

  const onRowDoubleClicked = (params) => {
    navigate('/editEmployee/' + selectedRows[0]?.employeeId)
  }

  useEffect(() => {
    if (selectedRows.length > 0) {
      setDeleteDisable(false)
    } else {
      setDeleteDisable(true)
    }
  }, [selectedRows])

  const onCellValueChanged = useCallback((params) => {
    const { data, colDef } = params;
    if (colDef.field === "reason") {
      if (data.reason === "POS Material" || data.reason === "Others") {
        data.picture = "Optional";
      } else if (data.reason === "Additional Requirement from Partner") {
        data.picture = "Picture/Doc";
      } else if (data.reason === "Missing element (reported by Factory)") {
        data.picture = "N/A";
      } else {
        data.picture = "Picture";
      }
    }
    // const colId = params.column.getId();
    // if (colId === 'reason') {
    //   const selectedCountry = params.data.reason;
    //   const selectedCity = params.data.picture;
    //   const allowedCities = reasonToPictureMap(selectedCountry);
    //   const cityMismatch = allowedCities.indexOf(selectedCity) < 0;
    //   if (cityMismatch) {
    //     params.node.setDataValue('picture', null);
    //   }
    // }
  }, []);

  const getContextMenuItems = useCallback((event) => {
    const result = [
      {
        name: "Add",
        icon: '<span><i class="material-icons style="font-size: 18px">perm_identity</i></span>',
        action: () => {
          onBtAdd(event);
        },
      },
      {
        name: "Delete",
        icon: '<span><i class="material-icons" style="font-size: 18px">delete</i></span>',
        action: () => {
          onBtDeleteRow(event);
        },
      },
      "separator",
      "copy",
      "export",
      "chartRange",
    ];
    return result;
  }, []);

  return (
    <>
      <ListPageHeader
        componentName="Trainers"
        // onBtExport={onBtExport}
        handlePurge={handlePurge}
        addPageLink="/addTrainers"
        pageName="Trainers List"
        // error={error}
        deleteDisable={deleteDisable}
        successMsg={successMsg}
        gridRef={gridRef}
        snackState={snackState}
      />
      <div className="p-24 pl-48">
        <div style={{ height: 350, width: "100%" }} className="relative">
          <Tooltip title={"Add Part"}>
            <Fab
              color="primary"
              variant="outlined"
              aria-label="add"
              className={classes.addButton}
              onClick={onBtAdd}
            >
              <Icon>add</Icon>
            </Fab>
          </Tooltip>
          <AgGridTable
            columnDefs={columnDefs}
            onGridReady={onGridReady}
            gridRef={gridRef}
            rowData={rowData}
            rowGroupPanelShow={"never"}
            rowHeight={35}
            headerHeight={36}
            getContextMenuItems={getContextMenuItems}
            onCellValueChanged={onCellValueChanged}
            hideCheckbox={true}
          />
        </div>
      </div>

      {/* //   <AgGridTable
      //     columnDefs={columnDefs}
      //     rowData={rowData}
      //     onGridReady={onGridReady}
      //     onSelectionChanged={onSelectionChanged}
      //     onRowDoubleClicked={onRowDoubleClicked}
      //     gridRef={gridRef}
      //     paginationPageSize={perPage}
      //     cacheBlockSize={perPage}
      //     saveGridStateName={'trainers'}
      //   />
      // </div> */}
    </>
  )
}

export default Trainers;